import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropType from "prop-types";
import { withRouter } from "react-router-dom";
import connectionActions from "../../../../../redux/connections/actions";
import styles from "./style.module.scss";
import musicImg from "../../../../../assets/images/music-card.png";

const Card = ({ user, history }) => {
  const dispatch = useDispatch();
  const { connections = [], sent = [], pending = [] } = useSelector(
    (state) => ({
      connections: state.connection.connections,
      pending: state.connection.pending,
      sent: state.connection.sent,
    })
  );

  const [canConnect, setCanConnect] = useState(true);

  useEffect(() => {
    const isSent = sent.findIndex((a) => a.user?.uid === user.uid) >= 0;
    const isPending = pending.findIndex((a) => a.user?.uid === user.uid) >= 0;
    const isConnected = connections.findIndex((a) => a.uid === user.uid) >= 0;
    if (isSent || isPending || isConnected) {
      setCanConnect(false)
    }
  }, [pending, connections, sent, user]);

  const connect = () => {
    dispatch({
      type: connectionActions.SEND_CONNECT_REQURST,
      payload: {
        userId: user.uid,
      },
    });
  };
  return (
    <div className={styles.cardContainer}>
      <div className={styles.imageContainer}>
        <div className={styles.layer1} />
        <div className={styles.layer2} />
        <div
          className={styles.image}
          style={{ backgroundImage: `url(${user?.profileImageUrl})` }}
        />
      </div>
      <div className={styles.songTitle}>
        {user.firstName} {user.lastName}
      </div>
      <div className={styles.actions}>
        <button className={styles.viewProfile} onClick={()=> history.push(`/user/${user.uid}`)}>View Profile</button>
        {canConnect && (
          <button className={styles.connect} onClick={connect}>
            Connect
          </button>
        )}

      </div>
    </div>
  );
};

Card.propTypes = {
  user: PropType.object,
  history: PropType.object
};

export default withRouter(Card);
